import React, { useState } from 'react';
import c from 'classnames';
const Accordion = _ref => {
  let {
    title,
    content,
    id,
    isInitiallyOpen,
    onOpen,
    onClose
  } = _ref;
  const [isExpanded, setIsExpanded] = useState(isInitiallyOpen);
  const classNames = c('faq-item', {
    'js-open': isExpanded
  });
  const onAccordionClick = React.useCallback(() => {
    if (isExpanded) {
      setIsExpanded(false);
      if (onClose) {
        onClose();
      }
      return;
    }
    setIsExpanded(true);
    if (onOpen) {
      onOpen();
    }
  }, [onClose, onOpen, isExpanded]);
  return /*#__PURE__*/React.createElement("article", {
    className: classNames
  }, /*#__PURE__*/React.createElement("button", {
    type: "button",
    "aria-expanded": isExpanded,
    "aria-controls": id,
    className: "faq-item__trigger p-0",
    onClick: onAccordionClick
  }, /*#__PURE__*/React.createElement("h3", {
    className: "h5"
  }, title)), /*#__PURE__*/React.createElement("div", {
    id: id,
    className: "faq-item__inner"
  }, /*#__PURE__*/React.createElement("div", null, content)));
};
export default Accordion;